module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3OxEL4/tc-custom/9780819572844.jpg?1704761694466",
      "alt": "This image is the cover for the book Fly Fishing in Connecticut"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fly Fishing in Connecticut\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Provides the essentials to launch a personal journey into the world of fly fishing")])]), _c('p', [_vm._v(" In this book, a long-time resident and devoted fly fisherman imparts a wealth of knowledge about fly fishing in Connecticut. Kevin Murphy teaches novice anglers about the state's trout hatcheries and stocking programs, the differences between brook, brown, and rainbow trout, and offers easy-to-follow instructions on the basics of fly fishing. In this concise text, the reader finds the essentials in fly fishing gear, stream tactics, casting, and a host of related topics. In addition, would-be anglers gain a useful glimpse into the history of fishing in the state, plus important tips on stream conservation, fly fishing etiquette, regulations, and safety. Most importantly, anglers will find a veritable road map to Connecticut's best trout streams and rivers. The book even offers excellent suggestions for comfortable lodging in prime fly fishing locations and—once the day's fishing is done—a few mouth-watering recipes for cooking one's catch. Whether you're in the market for that first pair of waders, thinking of tuning up your casting technique, or just want to know where the fish are biting, this is the book to read. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin Murphy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("KEVIN MURPHY is an independent historian and writer who lives in Rocky Hill, Connecticut. He is the author of Water for Hartford and Crowbar Governor.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wesleyan University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0